import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CtaBlock } from './CtaBlock';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="border-t border-ink-700 bg-ink-900 px-4 py-12 sm:px-6 sm:py-16" data-id="element-242" data-mp="3fycr5ou809bu">
      <div className="mx-auto w-full max-w-4xl" data-id="element-243" data-mp="3azjcht376ca3">
        <SectionHeading eyebrow="Was Schweißer sagen" title="Echte Ergebnisse in der Werkstatt" data-id="element-244" data-mp="3ayqd5d6kip1z" />

        <div className="mt-8 grid gap-4 md:grid-cols-3" data-id="element-245" data-mp="36wmotnysvpza">
          {testimonials.map(testimonial => <figure key={testimonial.name} className="flex flex-col rounded-2xl border border-ink-700 bg-ink-800 p-5" data-id="element-246" data-mp="2x0tf0ccgual7">
              <div className="flex items-center gap-3" data-id="element-247" data-mp="2s39ooe2hu7cw">
                <img src={testimonial.image} alt={testimonial.name} className="h-14 w-14 shrink-0 rounded-full object-cover" width={112} height={112} loading="lazy" data-id="element-248" data-mp="v9ygvdusdzbb" />
                <figcaption className="min-w-0" data-id="element-249" data-mp="m4rmy9btd84u">
                  <p className="font-semibold leading-tight text-white" data-id="element-250" data-mp="m6m91qytn6ai">{testimonial.name}</p>
                  <p className="mt-0.5 text-xs leading-snug text-white/55" data-id="element-251" data-mp="79258ndnvh5x">{testimonial.role}</p>
                </figcaption>
              </div>

              <div className="mt-3 flex gap-0.5" aria-label="5 von 5 Sternen" data-id="element-252" data-mp="zwfvk2muteh2">
                {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-brand text-brand" aria-hidden="true" data-id="element-253" data-mp="14u7nuxrev2ls" data-mpi={index} />)}
              </div>

              <blockquote className="mt-3 text-[15px] leading-relaxed text-white/75" data-id="element-254" data-mp="v3wjxb7q8tew">
                „{testimonial.quote}“
              </blockquote>
            </figure>)}
        </div>

        <CtaBlock label="Ich will die gleichen Ergebnisse" showTimer={false} note="Über 1.200 Schweißer nutzen das System bereits." className="mt-8" data-id="element-255" data-mp="1nnlfasvx0qwn" />
      </div>
    </section>;
}